exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".reserve-option-stocks-container th[data-v-0dd8c724]{background-color:#f5f5f5}.reserve-option-stocks-container td[data-v-0dd8c724],.reserve-option-stocks-container th[data-v-0dd8c724]{text-align:center!important;vertical-align:middle}.reserve-option-stocks-container input[type=number][data-v-0dd8c724]{text-align:left;padding-left:8px}", ""]);

// exports
